import { Col, Form, Input, message, Row } from "antd";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { GetSettingData, newsletter } from "../../utils/API";
import { FaLocationDot } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { PiArrowBendRightDownBold } from "react-icons/pi";
import logo from '../../assets/frontendassets/Logos/final net4surge logo.jpg';

const Footeruser = () => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [settings, setSettings] = useState<any>({});

  const handleSubscribe = async (values: any) => {
    setIsSubmitting(true);
    try {
      const response = await newsletter(values);
      if (response.status === 200) {
        form.resetFields();
        message.success("Subscribed successfully!");
      }
    } catch (error) {
      message.error("Subscription failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchSettingsData = async () => {
      try {
        const response = await GetSettingData();
        setSettings(response.settings[0]);
      } catch (error) {
        console.error('Failed to fetch settings data:', error);
      }
    };
    fetchSettingsData();
  }, []);

  const contactInfo = [
    {
      icon: <FaLocationDot className="text-black" size={20} />,
      title: "Locations",
      content: settings?.address || "Loading...",
      href: `https://www.google.com/maps/search/?q=${encodeURIComponent(settings?.address || "Your Location")}`
    },
    {
      icon: <IoIosMail className="text-black" size={20} />,
      title: "Send Mail",
      content: settings?.contactEmail || "contact@net4Surge.com",
      href: `mailto:${settings?.contactEmail || "contact@net4Surge.com"}`
    },
    {
      icon: <IoCall className="text-black" size={20} />,
      title: "Call Anytime",
      content: settings?.phone || "9319270033",
      href: `tel:${settings?.phone || "9319270033"}`
    }
  ];

  const exploreLinks = [
    { to: "/mlm/login", text: "Rapidexie login" },
    { to: "/about-us", text: "About us" },
    { to: "/backend/profile", text: "My Account" },
    { to: "/listing", text: "All Listing" },
    { to: "/contact-us", text: "Contact Us" }
  ];

  return (
    <>
      <div className="bg-[#11161F] bg-opacity-90 relative">
        <div className="absolute inset-0 bg-[url('https://gaviaspreview.com/wp/lestin/wp-content/uploads/2023/07/bg-footer.png')] opacity-20 bg-cover bg-bottom-left" />
        <div className="relative z-10">
          <div className="container mx-auto px-4 py-16">
            <Row gutter={[32, 48]}>
              {/* Logo and Description */}
              <Col xs={24} md={12} xl={8}>
                <img src={logo} alt="Logo" className="w-44 mb-6 transition-all duration-300 hover:opacity-90" />
                <p className="text-gray-300 text-base leading-relaxed max-w-md font-manrope">
                  We help SMBs and enterprises leverage digital technology to simplify their business and grow online.
                </p>
              </Col>

              {/* Explore Links */}
              <Col xs={24} md={12} xl={4}>
                <h3 className="text-white text-2xl font-bold mb-6 font-manrope">Explore</h3>
                <div className="flex flex-col space-y-3">
                  {exploreLinks.map((link) => (
                    <Link 
                      key={link.to}
                      to={link.to}
                      className="text-gray-300 hover:text-[#F9B138] transition-colors duration-200"
                    >
                      {link.text}
                    </Link>
                  ))}
                </div>
              </Col>

              {/* Contact Information */}
              <Col xs={24} md={12} xl={6}>
                <h3 className="text-white text-2xl font-bold mb-6 font-manrope">Contact</h3>
                <div className="space-y-6">
                  {contactInfo.map((info, index) => (
                    <a key={index} href={info.href} target="_blank" rel="noopener noreferrer" className="flex items-start space-x-4">
                    <div className="bg-[#F9B138] p-3 rounded-full">
                      {info.icon}
                    </div>
                    <div>
                      <p className="text-gray-400 font-semibold mb-1">{info.title}</p>
                      <p className="text-white font-manrope hover:underline">{info.content}</p>
                    </div>
                  </a>
                  ))}
                </div>
              </Col>

              {/* Newsletter */}
              <Col xs={24} md={12} xl={6}>
                <div className="bg-[#191f29] p-6 rounded-lg">
                  <div className="flex items-center mb-4">
                    <h3 className="text-white text-xl font-bold font-manrope">NEWSLETTER</h3>
                    <PiArrowBendRightDownBold size={24} className="text-[#F9B138] ml-2" />
                  </div>
                  <p className="text-gray-300 mb-6 font-manrope">
                    Subscribe to our newsletter to get our daily latest news and updates.
                  </p>
                  <Form form={form} onFinish={handleSubscribe}>
                    <Form.Item
                      name="email"
                      rules={[
                        { type: "email", message: "Please enter a valid email!" },
                        { required: true, message: "Email is required!" }
                      ]}
                    >
                      <Input
                        size="large"
                        className="rounded-md border-0"
                        placeholder="Email address"
                      />
                    </Form.Item>
                    <button
                      disabled={isSubmitting}
                      className="w-full bg-[#F9B138] text-white font-bold py-3 px-6 rounded-md hover:bg-[#e5a332] transition-colors duration-200"
                    >
                      {isSubmitting ? "Subscribing..." : "Subscribe now"}
                    </button>
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <footer className="bg-[#F9B138] py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8">
            <Link to="/contact-us" className="text-black hover:text-gray-800 font-semibold">
              Contact Us
            </Link>
            <div className="hidden md:block w-px h-6 bg-black/50" />
            <Link to="/privacy-policy" className="text-black hover:text-gray-800 font-semibold">
              Privacy Policy
            </Link>
            <div className="hidden md:block w-px h-6 bg-black/50" />
            <Link to="/terms-and-conditions" className="text-black hover:text-gray-800 font-semibold">
              Terms and Conditions
            </Link>
          </div>
          <p className="text-center text-black mt-4 font-manrope">
            © {settings?.copyrightYear || "2024"} Net4Surge All Rights Reserved
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footeruser;